import * as L from 'leaflet';
import 'leaflet-fullscreen';
import { addClassNames } from './lib/utils/dom';
/**
 * The fullscreen control.
 * {@link leaflet-fullscreen}
 */
export class ControlFullscreen extends L.Control.Fullscreen {
    /**
     * Create a new fullscreen control instance.
     * @param options - The fullscreen control options.
     * @param maap - The M.A.A.P. instance.
     */
    constructor(options, maap) {
        super(options);
        this._maap = maap;
        this.addEventListeners(maap);
    }
    /**
     * Add the custom fullscreen control markup.
     */
    addCustomMarkup() {
        const ControlFullscreenClassSelector = '.leaflet-control-fullscreen';
        const ControlFullscreen = this._maap.querySelector(ControlFullscreenClassSelector);
        if (ControlFullscreen) {
            addClassNames(ControlFullscreen, [
                'maap_c-control',
                'maap_p-bottom-controls__control',
                'maap_p-bottom-controls__control--button',
                'maap_p-control-fullscreen',
            ]);
        }
        const ControlFullscreenButton = this._maap.querySelector(`${ControlFullscreenClassSelector}-button`);
        if (ControlFullscreenButton) {
            ControlFullscreenButton.setAttribute('data-testid', 'fullscreen-toggle');
            addClassNames(ControlFullscreenButton, [
                'maap_c-icon-container',
                'maap_p-control-fullscreen__button',
            ]);
            const icon = document.createElement('span');
            addClassNames(icon, [
                'maap_c-icon-container__icon',
                'maap_p-control-fullscreen__icon',
            ]);
            ControlFullscreenButton.appendChild(icon);
        }
    }
    /**
     * Add event listeners for fullscreen control.
     * @param maap - The M.A.A.P. instance
     */
    addEventListeners(maap) {
        // Retreive the map management instance.
        const map = maap.map;
        const leafletMap = map._map;
        // Use the native fullscreen API to add event listeners for chaning from and
        // to fullscreen.
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/fullscreenchange_event
        leafletMap.on('fullscreenchange', () => {
            // If there are boundaries defined with the initial options, make the
            // map fit them whenever the fullscreen is de-/activated. If no boundaries
            // are defined, just reset the map view to the initial center point and
            // zoom level.
            const maxBounds = map.options.maxBounds;
            const resetView = maxBounds
                ? () => leafletMap.fitBounds(maxBounds)
                : () => leafletMap.setView(map.options.center, map.options.zoom);
            resetView();
            // As the map might change it's zoom level when toggling to/from
            // fullscreen need to run resetView again whenever the zoomend
            // event is fired.
            leafletMap.once('zoomend', resetView);
        });
    }
}
//# sourceMappingURL=ControlFullscreen.js.map